<template>
  <div class="bill-verification">
    <!-- tab切换 -->
    <div class="bill-verification-top">
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
        
      </div>
      <div class="btn-container">
        <div class="upload-warehouse" @click="openEntry">
          <span class="upload-warehouse-img"></span>
          <span>导入</span>
        </div>
      </div>
    </div>

    <div class="bill-verification-container">
      <div class="search-container">
        <div class="screen">
          <span class="screen-title">仓库名称：</span>
          <el-select 
            clearable 
            v-model="searchForm.warehouseId" 
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span class="screen-title">承运商：</span>
          <el-select
            v-model="searchForm.expressType"
            placeholder="请选择"
          >
            <el-option
              v-for="item in expressList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span class="screen-title">日期：</span>
          <el-date-picker
            v-model="searchForm.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
          ></el-date-picker>
          <el-button icon="el-icon-search" class="btn-blue" @click="onSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" class="btn-gray" @click="clearData">重置</el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="table"
          :data="tableData"
          style="width: 100%"
          :header-cell-class-name="headerCellClassName"
        > 
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            :min-width="item.width"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:item.prop === 'statusVal'?'status-cell':''"
          >
            <template slot-scope="scope">
              <div 
                style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;"
              >
                {{scope.row[item.prop]}}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 导入 -->
    <el-drawer
      title="导入"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <div class="tips">
          <img class="sign-blue" src="~assets/images/sigh/sigh-blue.png">
          <span class="tips-content">导入退件拦截费用单，费用将被计算进入客户月账单</span>
          <span class="tips-text">（功能介绍）</span>
        </div>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="entryForm.date"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="仓库名称" prop="warehouseId">
          <el-select 
            class="white"
            clearable
            v-model="entryForm.warehouseId"
            placeholder="请选择仓库名称"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="承运商" prop="expressType">
          <el-select
            v-model="entryForm.expressType"
            filterable
            clearable
            class="white"
            placeholder="请选择承运商"
          >
            <el-option
              v-for="item in expressList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下载导入模板">
          <div class="download-tmp" @click="downTmp">
            账单导入模板.xlsx
            <img class="upload-bottom" src="~assets/images/upload/upload-bottom.png">
          </div>
        </el-form-item>
        <el-form-item label="账单导入">
          <el-input v-if="!uploadFileName" v-model="uploadFileName" placeholder="请上传文件" disabled>
            <template slot="suffix">
              <el-upload
                v-loading.fullscreen.lock="loading"
                element-loading-text="文件上传中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                class="upload"
                ref="upload"
                action="#"
                :show-file-list="false"
                :auto-upload="true"
                :before-upload="uploadWarehouseLocationExcel"
              >
                <img class="upload-img" src="~assets/images/home/upload.png">
              </el-upload>
            </template>
          </el-input>
          <div v-else class="show-name">
            <span>{{ uploadFileName }}</span>
            <img @click="clearUploadFileName" src="~assets/images/close.png">
          </div>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import expressMixins from "@/common/mixins/express.js"
import warehouseMixins from "@/common/mixins/warehouse.js"
import LogisticsVerification from "models/logistics-verification";
import { downLoadFile, numsToRMBSymbolAndMillimeter, } from "common/js/util";
export default {
  mixins: [warehouseMixins, expressMixins],

  data() {
    return {
      selectedTab: '物流加收费',
      menuList: [
        { name: '重量核验', url: '/operate/finance/logisticsVerification/weightVerification' },
        { name: '金额核验', url: '/operate/finance/logisticsVerification/amountVerification' },
        { name: '物流加收费', url: '/operate/finance/logisticsVerification/logisticsPlusCharges' },
      ],
      searchForm: {
        warehouseId: '',
        expressType: '',
        month: ''
      },
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '120', alignment:'left'},
        {label: '仓库名称', prop: 'warehouseName', width: '', alignment:'left'},
        {label: '承运商名称', prop: 'expressName', width: '', alignment:'left'},
        {label: '金额', prop: 'amount', width: '', alignment:'right'},
      ],
      drawer: false,
      entryForm: {
        warehouseId: '',
        expressType: '',
        date: ''
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库名称', trigger: 'change' }
        ],
        expressType: [
          { required: true, message: '请选择承运商', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择月份', trigger: 'change' }
        ]
      },
      loading: false,
      uploadFileName: '',
      /* 订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    }
  },

  created() {
    this.initWarehouse()
    this.initExpressList()
    this.initList()
  },

  activated() {
    this.selectedTab = '物流加收费'
  },

  methods: {
    /** 
     * @desc 物流加收费列表
    */
    initList() {
      let reportDate = this.searchForm.month
      let warehouseId = this.searchForm.warehouseId
      let expressType = this.searchForm.expressType
      let data = {
        warehouseId,
        expressType,
        reportDate
      }
      LogisticsVerification.getLogisticsPlusChargesList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.createTime = i.reportDate
            obj.warehouseName = i.warehouseName
            obj.expressName = i.expressTypeName
            obj.amount = numsToRMBSymbolAndMillimeter(i.amount)
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex}) {
      if (columnIndex == 3) {
        return 'right-align'
      }
    },

    onSearch() {
      this.initList();
    },

    clearData() {
      this.searchForm.month = ''
      this.searchForm.warehouseId = ''
      this.searchForm.expressType = ''
    },
    
    /** 
     * @desc 打开导入
    */
    openEntry() {
      this.drawer = true
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let expressType = this.entryForm.expressType
          let reportDate = this.entryForm.date
          
          if (this.isUpload) {
            return this.$message.error("请导入文件");
          }
          let formData = this.formData
          if (formData.get('warehouseId')) {
            formData.delete('warehouseId')
          }
          if (formData.get('reportDate')) {
            formData.delete('reportDate')
          }
          if (formData.get('expressType')) {
            formData.delete('expressType')
          }
          formData.append("warehouseId", warehouseId);
          formData.append("reportDate", reportDate);
          formData.append("expressType", expressType);

          LogisticsVerification
            .postLogisticsPlusChargesExcel(formData)
            .then(res => {
              if (res.success) {
                this.$message.success("导入成功");
                this.initList()
                this.handleCloseDrawer()
              } else {
                this.$confirm(res.message, "提示", {
                  showCancelButton: false,
                  confirmButtonText: "确定",
                  type: "warning"
                }).then(() => {});
              }
            })
            .catch(res => {
              console.log(res);
              this.$message.error("导入失败");
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    handleCloseDrawer() {
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.entryForm.expressType = ''
      this.removeUploadOrder()
      this.drawer = false
    },
    
    removeUploadOrder() {
      this.formData = null
      this.isUpload = true
      this.uploadFileName = ''
    },
    
    downTmp() {
      let fileName = '账单导入模板'
      let url = 'https://zzd-fire-test.oss-cn-hangzhou.aliyuncs.com/zzd/excelModel/%E9%80%80%E4%BB%B6%E6%8B%A6%E6%88%AA%E8%B4%B9%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      downLoadFile(fileName, url)
    },

    //导入Excel表格
    uploadWarehouseLocationExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadFileName = file.name
      this.isUpload = false
      if (file) {
        this.loading = false
      }
      return false;
    },
    

    /**
     * @desc 删除上传文件
     */
    clearUploadFileName() {
      this.uploadFileName = ''
      let formData = this.formData
      this.isUpload = true
      if (formData.get('file')) {
        formData.delete('file')
      }
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/operator/bill-verification.scss';
</style>
